import { render, staticRenderFns } from "./entity-membership-manager.vue?vue&type=template&id=5e4c8870&"
import script from "./entity-membership-manager.vue?vue&type=script&lang=ts&"
export * from "./entity-membership-manager.vue?vue&type=script&lang=ts&"
import style0 from "./entity-membership-manager.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports